'use strict';

import animalHouseData from '../extend/AnimalHouseData';

const ol = require('openlayers');

/**
 * @name MapOptions
 * @type {Object}
 * @property {string} type
 * @property {EventEmitter} mapEvents
 * @property gmap_selector
 * @property gmap_options_default
 * @property gmap_options
 * @property placeType
 * @property outer_frame_selectors
 * @property container_selector
 * @property outer_frame_selectors
 * @property icon_default
 * @property facility_type_name_table
 * @property place_image_path
 */

class OpenLayerLatLng {
  /**
   * @param {ol.Coordinate}
   */
  constructor(coord) {
    this.coord = coord;
  }
  
  lat() {
    return this.coord[1];
  }
  
  lng() {
    return this.coord[0];
  }
  
  toCoordinate() {
    return this.coord;
  }
}

/**
 * OpenLayerで表示する
 * 
 * @name OpenLayerMap
 * @extends {Map}
 */
export default class OpenLayerMap{
  
  /**
   * @param {EventEmitter} mapEvents
   * @param {PopupFactory} popupFactory
   * @param {PlaceType} placeType
   * @param {MapOptions} options
   */
  constructor(mapEvents, popupFactory, placeType, options) {
    this.mapEvents = mapEvents;
    this.popupFactory = popupFactory;
    this.placeType = placeType;
    this.options = options;
    this.omarkers = {};
  }
  
  /**
   * 初期化
   *
   * @access public
   */
  reset() {
    
    // マップサイズ調整（マップ描画前に実行しないと表示が崩れる）
    this.adjustMapSize();
  
    // ポップアップ表示用のDOMの設定
    // $('#gmap').append('<div id="popup"></div>');
    
  }
  
  /**
   * ih.start()で呼ばれる
   *
   * @access public
   */
  start() {
    this.olmap = this.createMap();
  }
  
  /**
   * マップサイズの調整
   * resizeイベント割当はcoreが行う
   *
   * @access public
   * @returns {void}
   */
  adjustMapSize(){
    var minus = _.reduce(this.options.outer_frame_selectors, function(val, frame){
      return val + $(frame).height() + 0;
    }, 0);
    
    var height = window.innerHeight - minus; // iPhone safari: height()だとアドレスバーの部分が引かれた値になる
    var width = $(window).width();
    
    var container = $(this.options.container_selector);
    container.height(height);
    var map_canvas = $(this.options.gmap_selector);
    
    // マップキャンバスのサイズを調整（横幅が1024pxを越える時、パネルエリア分縮める）
    var side = 0;
    if (width >= 1024){
      side = 390;
    }
    map_canvas.width(width - side);
    //map_canvas.width(width - $('.panel-content').width());
    
    map_canvas.height(height);
  }
  
  /**
   * マップを作成
   *
   * @access private
   * @returns {ol.Map}
   */
  createMap() {
  
    // マーカ吹き出し用のDOMの設定
    $('#gmap').append('<div id="popup"></div>');
    
    // 吹き出しを閉じるボタンの配置・デザイン
    $('#popup').append('<a href="#" id="popup-closer">×</a>');
    $('#popup-closer').css({
      'font-size': '20px',
      'text-decoration': 'none',
      'position': 'absolute',
      'top': '0px',
      'right': '8px'
    });
    
    // マップを描画するラスタレイヤ
    var rasterLayer = new ol.layer.Tile({
      source: new ol.source.XYZ({
        url: '../sites/tennoji-zoo/assets/img/tiles/{z}/{x}/{y}.png',
        projection: 'EPSG:3857'
      })
    });
    
    // 動物マーカ用のベクタレイヤ
    var vectorSource = new ol.source.Vector({});
    var vectorLayer = new ol.layer.Vector({
      source: vectorSource
    });
  
    // 施設マーカ用のベクタレイヤ
    var vectorSourceF = new ol.source.Vector({});
    var vectorLayerF = new ol.layer.Vector({
      source: vectorSourceF
    });
    
    // 吹き出し用のオーバーレイ
    var popupOverlay = new ol.Overlay({
      element: document.getElementById('popup'),
      positioning: 'center-center',
      stopEvent: true // ポップアップをクリックした時に、下に隠れたマーカが反応しないようにする
    });
    
    // 表示する地域の限界座標
    var extent = ol.proj.transformExtent([135.5066, 34.6486, 135.5097, 34.6539], 'EPSG:4326', 'EPSG:3857');
  
  　// タイル画像の表示地域を限定
    // rasterLayer.setExtent(extent);
  
    // ベクタレイヤ・オーバーレイをクラスプロパティ化
    this.vectorSource = vectorSource;
    this.layer = vectorLayer;
    this.overlay = popupOverlay;
  
    this.vectorSourceF = vectorSourceF;
    this.layerF = vectorLayerF;
    
    // マップのビューの定義
    var view = new ol.View({
      projection: "EPSG:3857",
      extent: extent, // マップの可動域を限定
      rotation: 4.453,
      zoom: this.options.gmap_options_default.zoom,       // 17 (z.coreで指定)
      maxZoom: this.options.gmap_options_default.maxZoom, // 20 (z.coreで指定)
      minZoom: this.options.gmap_options_default.minZoom  // 16 (z.coreで指定)
    });

    // マップの定義・描画
    var map = new ol.Map({
      target: this.options.gmap_selector.replace(/#/g, ''), // gmap (z.coreで指定, 元は '#gmap' なので '#' を削除)
      layers: [rasterLayer, vectorLayer, vectorLayerF],
      overlays: [popupOverlay],
      view: view,
      controls: ol.control.defaults({
        attributionOptions: ({
          collapsible: false
        })
      }).extend([
        new ol.control.ScaleLine()
      ])
    });
  
    // 拡大・縮小ボタンのスライダーの設定
    map.addControl(new ol.control.ZoomSlider());
    $('.ol-zoomslider').css({
      'border': '1px solid darkgray'
    });
    
    // マーカクリックイベント
    var that = this;
    map.on('click', function(event) {
    
      var marker = map.forEachFeatureAtPixel(event.pixel, function(marker) {
        return marker;
      });
    
      // ポップアップを生成する
      if (marker) {
        if(marker.get('id') === null){
          return;
        }
        that.createMarkerPopup(marker);
      }
    });
    
    $('#popup-closer').on('click', function () {
      //$('#popup').empty();
      $('.info-window').remove();
      popupOverlay.setPosition(undefined);
      $(this).blur();
      return false;
    });
    
    // 北向きボタンを無効化（方位マークとして扱う）
    // $('.ol-rotate-reset').prop('disabled', true);
    
    // 北向きボタンを押すと、地図の向きを初期位置に戻す（新世界ゲートが手前）
    $('.ol-rotate-reset').on('click', function () {
      map.getView().setRotation(4.453);
    });
    
    // ピンチ操作などで指定ズーム範囲を越えると(解像度の変化で判定)、指定ズーム範囲に抑える
    map.getView().on('change:resolution', function(e){
      if(parseFloat(e.oldValue) > 1.2){
        map.getView().setZoom(17);
      }
      if(parseFloat(e.oldValue) < 0.297){
        map.getView().setZoom(19);
      }
    });
    
    return map;

  }
  
  /**
   * マップ中心位置、基準位置を変更する
   * 
   * @access public
   * @param {OpenLayerLatLng} latlng
   */
  setCenterAndCurrentLocation(latlng) {
    
    // OpenLayerLatLngをol.Coordinateに変換して中心位置をセット
    this.olmap.getView().setCenter(latlng.toCoordinate());
    
    // 現在の基準位置を更新
    this.updateCurrentLocation(latlng);
  
    // this.olmap.on('moveend', this.displayCenterMarker);
    
  }
  
  /**
   * 検索の基準位置を変更する
   *
   * @access public
   * @param {OpenLayerLatLng} latlng
   * @returns {OpenLayerLatLng}
   */
  updateCurrentLocation(latlng) {
    
    if (!latlng) {
      var c = this.olmap.getView().getCenter();
      latlng = this.createLatLng(c[0], c[1]);
    }
    
    // 基準位置マーカを表示する
    // this.displayBaseMarker(latlng);
  
    this.displayFacilityName();
  
    this.current_search_location = latlng;
    return this.current_search_location;
    
  }
  
  /**
   * 検索時の基準位置を取得する
   *
   * @access public
   * @returns {OpenLayerLatLng}
   */
  getCurrentSearchLocation(){
    return this.current_search_location;
  }
  
  /**
   * 基準位置マーカーを表示
   *
   * @param {OpenLayerLatLng} latlng
   */
  displayBaseMarker(latlng) {
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(latlng.toCoordinate()),
      id: null,
      name: '近つ飛鳥博物館'
    });
    
    // マーカのスタイル設定（画像, 文字）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/pin/base_pin.png',
      }),
      text: new ol.style.Text({
        fill: new ol.style.Fill({color: "red"}),
        stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
        scale: 1.4,
        textAlign: "center",
        offsetY: 0,
        text: '近つ飛鳥博物館'
      })
    }));
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  displayCurrentLocationMarker(latlng){
    
    // 現在地マーカが表示済みの場合、一旦削除
    if(this.layerM){
      this.clearCurrentLocationMarker();
    }
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(latlng.toCoordinate()),
      id: null,
      name: '現在地'
    });
  
    // マーカのスタイル設定（画像, 文字）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/pin/base_pin.png',
      }),
      text: new ol.style.Text({
        fill: new ol.style.Fill({color: "red"}),
        stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
        scale: 1.4,
        textAlign: "center",
        offsetY: 0,
        text: '現在地'
      })
    }));
  
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
  
    this.layerM = layer;
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  existCurrentLocationMarker(){
    if(!this.layerM){
      return false;
    } else {
      if(this.layerM.getSource().getFeatures().length == 0){
        return false;
      } else {
        return true;
      }
      
    }
  }
  
  clearCurrentLocationMarker(){
    this.layerM.getSource().clear();
  }
  
  /**
   * 中心位置マーカーを表示
   *
   *
   */
  displayCenterMarker(evt) {
    
    var map = evt.map;
    
    if(this.layerCM){
      this.layerCM.getSource().clear();
    }
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(map.getView().getCenter()),
      id: null
    });
    
    // マーカのスタイル設定（画像）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/center_marker.png',
        scale: 0.8
      })
    }));
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
    
    // ベクタレイヤをマップに追加
    map.addLayer(layer);
    
    this.layerCM = layer;
    
  }
  
  /**
   * 施設名のみ（マーカなし）をFeature形式で表示
   *
   *
   */
  displayFacilityName() {
    
    var facilities = animalHouseData;
    var features = [];
    
    for(var i = 0; i < facilities.length; i++){
      
      // マーカの内容設定（座標, id, 名称, 種別）
      features[i] = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([facilities[i].lng, facilities[i].lat], "EPSG:4326", "EPSG:3857")),
        id: facilities[i].id,
        name: facilities[i].name,
        lat: facilities[i].lat,
        lng: facilities[i].lng,
        facilities: facilities
      });
  
      // マーカのスタイル(画像, 文字)をズームレベルによって動的設定
      features[i].setStyle(new ol.style.Style({
        text: new ol.style.Text({
          fill: new ol.style.Fill({color: "red"}),
          stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
          scale: 1.0,
          textAlign: "center",
          offsetY: 0,
          text: facilities[i].name
        })
      }));
  
    }
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: features
      })
    });
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  /**
   * 検索範囲を指定した場合に用いる、円を表示
   *
   * @access public
   * @param r
   */
  displayCircle(r) {
  }
  
  /**
   * マーカーを全消去
   *
   * @access public
   */
  clearMarkersAll() {
    
    if(this.layer){
      this.layer.getSource().clear();
      //$('#popup').empty();
      $('.info-window').remove();
      this.overlay.setPosition(undefined);
    }
    
  }
  
  /**
   * 現在表示中のマーカーを取得
   *
   * @access public
   * @returns {Array.<google.maps.Marker>}
   */
  getDisplayMarkers(){
    
  }
  
  /**
   * 施設マーカーを取得
   *
   * @access public
   * @param id
   * @returns {google.maps.Marker}
   */
  getPlaceMarker(id){
    
  }
  
  /**
   * マーカーを地図上にプロットする
   *
   * @access public
   * @param {Request} request
   * @param {Array} places
   */
  displayMarkers(request, places) {
    
    // ズーム・中心座標を初期値に戻す
    this.fitBounds(places);
  
    var markers = [];
    
    for (var i = 0, len = places.length; i < len; i++) {
    
      var place = places[i];
      if (!place) continue;
    
      // マーカーを生成
      markers[i] = this.createMarker(place);
      
    }
    
    // マーカをベクタレイヤに追加
    this.vectorSource.addFeatures(markers);
  
    // マーカ上でマウスカーソルを変更
    var that = this;
    var target = this.olmap.getTarget();
    var jTarget = typeof target === "string" ? $("#" + target) : $(target);
    $(this.olmap.getViewport()).on('mousemove', function (evt) {
      var pixel = that.olmap.getEventPixel(evt.originalEvent);
      var hit = that.olmap.forEachFeatureAtPixel(pixel, function (feature, layer) {
        return true;
      });
      if (hit) {
        jTarget.css("cursor", "pointer");
      } else {
        jTarget.css("cursor", "");
      }
    });
    
  }
  
  displayFacilityMarkers(places){
    
    // マーカ表示済みの場合、一旦全て削除する
    if(this.layerF){
      this.layerF.getSource().clear();
      $('.info-window').remove();
      this.overlay.setPosition(undefined);
    }
    
    // ズーム・中心座標を初期値に戻す
    this.fitBounds(places);
  
    var markers = [];
  
    for (var i = 0, len = places.length; i < len; i++) {
    
      var place = places[i];
      if (!place) continue;
    
      // マーカーを生成
      markers[i] = this.createMarker(place);
    }
  
    // マーカをベクタレイヤに追加
    this.vectorSourceF.addFeatures(markers);
  
    // マーカ上でマウスカーソルを変更
    var that = this;
    var target = this.olmap.getTarget();
    var jTarget = typeof target === "string" ? $("#" + target) : $(target);
    $(this.olmap.getViewport()).on('mousemove', function (evt) {
      var pixel = that.olmap.getEventPixel(evt.originalEvent);
      var hit = that.olmap.forEachFeatureAtPixel(pixel, function (feature, layer) {
        return true;
      });
      if (hit) {
        jTarget.css("cursor", "pointer");
      } else {
        jTarget.css("cursor", "");
      }
    });
      
  }
  
  /**
   * 施設オブジェクト(Place)を基に、マーカを生成し、omarkersで管理する
   *
   * @access protected
   * @param {Place} place
   * @returns {ol.Feature}
   */
  createMarker(place) {
    
    if (!place) return;

    if (!this.omarkers['places']) {
      this.omarkers['places'] = {};
    }

    // 対象のマーカが生成済みならそのまま返す？
    if (this.omarkers['places'][place.id]){
      return this.omarkers['places'][place.id];
    }
    
    // マーカー生成
    var marker = this._createMarkerObject(place);
    
    // 生成したマーカを保持？
    this.omarkers['places'][place.id] = marker;
    
    return marker;
    
  }
  
  /**
   * マーカ(ol.Feature)を生成する
   * オーバーライド許可するが、markerを内部管理する必要があるのでcreateMarker以外からは呼ばないように
   *
   * @access private
   * @param {Place} place
   * @returns {ol.Feature}
   */
  _createMarkerObject(place){
    
    // マーカの内容設定（座標, id, 名称, 種別）
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.transform([place.lng, place.lat], "EPSG:4326", "EPSG:3857")),
      id: place.id,
      name: place.name,
      type: place.type,
      lat: place.lat,
      lng: place.lng,
      place: place
    });
  
    // マーカのスタイル(画像, 文字)をズームレベルによって動的設定
    feature.setStyle((resolution) => {
      
      // ズームレベル16, 17の時 = resolution(解像度)が1以上の時、動物名は最初の2文字のみにする
      if (resolution > 1) {
        return new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 40],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '../sites/tennoji-zoo/assets/img/pin/' + place.type + '_pin.png'
            //src: this.placeType.getMarkerIcon(place.type)
          }),
          text: new ol.style.Text({
            fill: new ol.style.Fill({color: "navy"}),
            stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
            scale: 1.4,
            textAlign: "center",
            offsetY: 0,
            text: place.name.substr(0, 2) + '...'
          })
        });
      // ズームレベル18以上の時
      } else {
        return new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 40],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '../sites/tennoji-zoo/assets/img/pin/' + place.type + '_pin.png'
          }),
          text: new ol.style.Text({
            fill: new ol.style.Fill({color: "navy"}),
            stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
            scale: 1.4,
            textAlign: "center",
            offsetY: 0,
            text: place.name
          })
        });
      }
    });
    
    return feature;
    
  }
  
  /**
   * マーカーのポップアップを生成し、イベントリスナーに登録する
   *
   * @access protected
   * @param {Array} places
   * @param {ol.Feature} markers
   * @return {DOMElement}
   */
  createMarkerPopup(marker){
    
    // クリックしたマーカの遺跡オブジェクトを取得
    var place = marker.get('place');
    
    // 遺跡オブジェクトを元にポップアップのDOMを生成
    var popup = this.popupFactory.build(place);
    
    // ポップアップDOMにdata-id(遺跡ID)を設定
    $(popup).data('id', place.id);
    
    // z.coreにクリックイベントを渡す（その後、ポップアップを開くかどうかはz.coreに任せる）
    this.mapEvents.emit('ihClickMarker', place, marker, popup);
    
    return popup;
    
  }
  
  /**
   * マーカーポップアップを開く
   *
   * @access public
   * @param marker
   * @param popup
   */
  toggleMarkerPopup(marker, popup){
    
    var that = this;
    
    // toggleする
    if (that.isOpenMarkerPopup(popup)){
      that.closeMarkerPopup();
    }else{
      that.setMarkerPopup(marker, popup);
    }
    
  }
  
  /**
   * 指定のマーカーポップアップが開いているか？
   *
   * @param popup
   * @returns {boolean}
   */
  isOpenMarkerPopup(popup){
    return $(popup).data('id') == $('.info-window').data('id');
  }
  
  /**
   * マーカーポップアップを閉じる
   *
   */
  closeMarkerPopup(){
    //$('#popup').empty();
    $('.info-window').remove();
    this.overlay.setPosition(undefined);
  }
  
  /**
   *
   * @param marker
   * @param popup
   */
  setMarkerPopup(marker, popup){
    this.overlay.setPosition(ol.proj.transform([marker.get('lng'), marker.get('lat')], "EPSG:4326", "EPSG:3857"));
    //$('#popup').empty();
    $('.info-window').remove();
    $('#popup').append(popup);
  }
  
  /**
   * 
   * @param lat
   * @param lng
   * @returns {OpenLayerLatLng}
   */
  createLatLng(lat, lng) {
    return new OpenLayerLatLng( ol.proj.fromLonLat( [parseFloat(lng), parseFloat(lat)] ) );
  }

  /**
   * 中心位置オブジェクトを取得
   *
   * @access public
   * @returns {OpenLayerLatLng}
   */
  getCenter() {
    return new OpenLayerLatLng(this.olmap.getView().getCenter())
  }
  
  /**
   *
   * @access public
   * @params {OpenLayerLatLng} latlng
   */
  setCenter(latlng) {
    // OpenLayerLatLngをol.Coordinateに変換して中心位置をセット
    this.olmap.getView().setCenter(latlng.toCoordinate());
  }
  
  /**
   *
   * @access public
   * @params {number} zoom
   */
  setZoom(zoom){
    this.olmap.getView().setZoom(zoom);
  }
  
  /**
   * 指定された座標に地図を移動させる
   *
   * @access public
   * @param {number} lat
   * @param {number} lng
   * @param {boolean?} circle
   * @return {boolean} 戻り値
   */
  moveMap(lat, lng, circle) {
  }
  /**
   * 指定施設に移動して、マーカークリック動作を起動
   * 
   * @access public
   * @param place
   */
  moveAndFocus(place){
  }
  /**
   * マーカーがクリックされた際の処理
   * 
   * @access public
   */
  focusMarker(place) {
    // focusMarker(markerNum) {
    
    /*
     * TODO: ol.Mapの、特定のfeatureの'click'イベントをtriggerする方法がわからない
     * 替わりに、EventEmitterで'ihClickMarker'を発生させている
     * そのためには、placeオブジェクトと、popupオブジェクトが必要なので、
     * focusMarker()のパラメータをmarkerNum(= place.id)からplaceオブジェクトに変更している
     * z.core.displaySearchResultRowのfocusMarker()のパラメータも合わせて変更している
     */
    
    if(place){
      var p = this.popupFactory.build(place);
      $(p).data('id', place.id);
      var m = this.omarkers['places'][place.id];
      this.mapEvents.emit('ihClickMarker', place, m, p);
    }
    
  }
  /**
   * 仕方なく外からgooglemapを操作したい時
   * 
   * @access public
   * @returns {google.maps.Map}
   */
  getMap() {
  }
  /**
   * 指定の施設が全て表示されるようにズームと位置調整する
   * 
   * @param {Array} places
   */
  fitBounds(places) {
    this.setCenter(this.getCurrentSearchLocation());
    this.setZoom(this.options.gmap_options_default.zoom);
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/map/OpenLayerMap.js